var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"note",class:_vm.note.type},[_c('div',{staticClass:"note-header"},[_vm._v(" "+_vm._s(_vm.note.type)+" ")]),_c('div',{staticClass:"note-content",domProps:{"innerHTML":_vm._s(_vm.note.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }